import React from "react";
import { Eye, EyeClosed } from "lucide-react";
import TrendingUp from "../../../assets/icons/TrendUp";
import TrendingDown from "../../../assets/icons/TrendDown";

const MetricCard = ({
  title,
  value,
  change,
  changeType,
  icon: Icon,
  iconColor,
  showValue = false,
  isVisible,
  onToggle,
}) => {
  const [localVisible, setLocalVisible] = React.useState(!showValue);
  const actualVisible = isVisible !== undefined ? isVisible : localVisible;
  const handleToggle = onToggle || setLocalVisible;


  const getChangeIcon = () => {
    return changeType === "positive" ? <TrendingUp /> : <TrendingDown />;
  };

  const displayValue = showValue && !actualVisible ? "********" : value;

  return (
    <div className="sales-metric-card">
      <div className="sales-metric-card-header">
        <div className="sales-metric-info">
          <p className="sales-metric-label">{title}</p>
          <div className="sales-metric-value-container">
            <h3 className="sales-metric-value">{displayValue}</h3>
            {showValue && (
              <button
                className="sales-metric-toggle-btn"
                onClick={() => handleToggle(!actualVisible)}
              >
                {actualVisible ? <Eye size={16} /> : <EyeClosed size={16} />}
              </button>
            )}
          </div>
          <div className="sales-trend-badge">
            <div
              className={`sales-trend-badge-content ${
                changeType === "positive" ? "positive" : "negative"
              }`}
            >
              {getChangeIcon()}
              <p className="sales-trend-badge-percentage">
                {Math.abs(change)}%
              </p>
            </div>
            <p className="sales-trend-badge-text">From last week</p>
          </div>
        </div>

        <img src={Icon} alt={title} />
      </div>
    </div>
  );
};

export default MetricCard;
